// extracted by mini-css-extract-plugin
export var image = "CustomSoftware-module--image--8edd0";
export var indahashImage = "CustomSoftware-module--indahash-image--5bbb9";
export var link = "CustomSoftware-module--link--65f7b";
export var scroll = "CustomSoftware-module--scroll--ca8cb";
export var typography = "CustomSoftware-module--typography--147de";